import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["role", "approver", "checkbox"]

  connect() {
    this.toggleApprover()
  }

  toggleApprover() {
    const approverEligible = ["accounting", "manager"].includes(this.roleTarget.value)

    this.approverTarget.classList.toggle("hidden", !approverEligible)
    if (!approverEligible) this.checkboxTarget.checked = false
  }
}
